const url = process.env.NODE_ENV === 'production' ? 'https://visa-application-form.sport-syy.com/ApplicantsOrder' : 'https://test-visa-application-form.sport-syy.com/ApplicantsOrder';
export const getEnvModelUrl = () => {
  return url
}
 